export interface NotebookReportItem {
  id: number;
  reporterUserName: string;
  reporterOpenId: string;
  notebookId: number;
  category: string;
  reason: string;
  content?: string;
  picture?: string[];
  createTime?: string;
  updateTime?: string;
}

export const REPORT_REASON_OPTIONS = [
  '政治敏感',
  '涉嫌广告',
  '恶意灌水',
  '低俗色情',
  '涉网络暴力',
  '虚假不实信息',
  '侵犯肖像、隐私、名誉等',
  '涉企侵权',
  '涉青少年有害信息',
  '涉互联网算法推荐举报',
  '其他'
];
